import { render, staticRenderFns } from "./SnapshotOperations.vue?vue&type=template&id=5583b00c"
import script from "./SnapshotOperations.vue?vue&type=script&lang=js"
export * from "./SnapshotOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports